export default "__VITE_ASSET__boCyqtvRJGsqAj3hj48oKA__"